export default __webpack_public_path__ + "static/media/login.d16b6047.jpg";